<template>
  <v-row>
    <template v-for="(field, idx) in configs.selector">
      <v-col v-bind="configs.label && configs.grid[idx]" :key="idx">
        <validation-provider
          :name="configs.label && configs.label[idx]"
          :rules="configs.required && configs.required[idx] === field ? 'required' : ''"
          v-slot="{ errors }"
        >
          <v-autocomplete
            :disabled="(configs.disabled && configs.disabled[idx]) || false"
            :items="items[field]"
            :label="
              (configs.label && configs.label[idx]) + (configs.required && configs.required[idx] === field ? ' *' : '')
            "
            :error-messages="errors"
            :name="field"
            item-text="text"
            item-value="value"
            :outlined="(configs.outlined && configs.outlined[idx]) || false"
            @change="onChange(idx)"
            no-data-text="-"
            v-model="formData[field]"
          />
        </validation-provider>
      </v-col>
      <slot name="extra" v-if="idx === configs.selector.length - 1" />
    </template>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { ValidationProvider } from 'vee-validate';
import { isObject } from '@/utils/format';
export default {
  name: 'Cascade',
  components: { ValidationProvider },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    configs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {},
      initValue: this.value || {},
      options: {},
      lastFetched: {},
      items: {},
    };
  },
  mounted() {
    // reset cascade
    // init value
    this.resetAll();
    this.update();
  },
  methods: {
    ...mapActions('master', ['getMasters']),

    isEmpty(obj) {
      return !isObject(obj);
    },

    resetAll() {
      const selector = this.$getDeepObj(this.configs, 'selector').length;
      for (let i = 0; i < selector; i += 1) {
        this.resetField(i);
      }
    },

    resetField(idx) {
      const key = this.$getDeepObj(this.configs, `selector.${idx}`);
      this.$set(this.formData, key, '');
    },

    onChange() {
      // this.$nextTick(() => {
      //   this.rChild(idx)
      // })
    },

    update() {
      const selector = this.$getDeepObj(this.configs, 'selector');
      selector.forEach((value, idx) => {
        // set parent opt
        if (idx === 0) {
          const opt = this.$getDeepObj(this.configs, `options.${idx}`) || {};
          this.$set(this.options, value, Object.assign({}, opt));
          // items
          this.setChildOptions(value);
        }
        this.$set(this.formData, value, this.$getDeepObj(this.initValue, value) || '');
        this.rChild(idx);
      });
    },

    rChild(idx) {
      const i = Number(idx);
      const options = {
        parent: this.$getDeepObj(this.configs, `selector.${i}`),
        parent_key: this.$getDeepObj(this.configs, `keys.${i}`) || '',
        child: this.$getDeepObj(this.configs, `selector.${i + 1}`),
        child_key: this.$getDeepObj(this.configs, `keys.${i + 1}`) || '',
        options: this.$getDeepObj(this.configs, `options.${i + 1}`),
      };

      const selectedOpt = this.$getDeepObj(this.formData, `${options.parent}`) || {};
      const selected =
        (selectedOpt && typeof selectedOpt === 'object' ? selectedOpt && selectedOpt.value : selectedOpt) || '';

      // set label
      if (this.configs.withLabel && selected) {
        this.formData[options.parent.replace('k_', '')] = this.$getDeepObj(
          this.options,
          `${options.parent}.${selected}`
        );
      }

      // return jika child undefined
      if (!options.child || !selected || options.options === 'input') {
        return;
      }

      // jika ada cek apakah config options adalah obj
      const hasOpt = !this.isEmpty(options.options);
      if (hasOpt) {
        // set opt
        this.options[options.child] = this.getMapMaster(options.options, selected);
        this.setChildOptions(options.child);

        // run callback
        if (typeof this.$getDeepObj(this.configs, 'callbacks') === 'function')
          this.$getDeepObj(this.configs, 'callbacks')(this.formData);
      } else {
        const key = (options.child_key || options.child).replace('k_', '');
        const params = {
          name: {
            0: key,
          },
          filter: {
            0: {
              [options.parent_key || options.parent]: selected,
            },
          },
        };

        // prevent looping
        const fetchKey = JSON.stringify(params);
        if (this.lastFetched[options.child] === fetchKey) return;
        this.lastFetched[options.child] = fetchKey;

        // request
        this.getMasters(params).then((resp) => {
          this.options[options.child] = resp[key] || {};
          // items
          this.setChildOptions(options.child);
          // run callback
          if (typeof this.$getDeepObj(this.configs, 'callbacks') === 'function')
            this.$getDeepObj(this.configs, 'callbacks')(this.formData);
        });
      }
    },

    setChildOptions(child) {
      // add items with options
      let remapOptions = Object.keys(this.options[child]).map((val) => {
        return { text: this.options[child][val], value: Number(val) };
      });
      // sort items
      // eslint-disable-next-line
      remapOptions.sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
      this.$set(this.items, child, remapOptions);
    },

    getMapMaster(options, selected) {
      const result = {};
      Object.keys(options).forEach((key) => {
        if (key.startsWith(selected)) {
          result[key] = options[key];
        }
      });

      return result;
    },
    mutate() {
      this.$emit('input', this.formData);
    },
  },
  watch: {
    formData: {
      handler() {
        this.mutate();
      },
      deep: true,
    },
    value: {
      handler(val) {
        this.initValue = val;
        this.update();
      },
      deep: true,
    },
    configs: {
      handler() {
        this.update();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
